import { render, staticRenderFns } from "./warehouse-products-table.vue?vue&type=template&id=6066fc82&scoped=true&"
import script from "./warehouse-products-table.vue?vue&type=script&lang=js&"
export * from "./warehouse-products-table.vue?vue&type=script&lang=js&"
import style0 from "./warehouse-products-table.vue?vue&type=style&index=0&id=6066fc82&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6066fc82",
  null
  
)

export default component.exports